const MessageInput = ({message, handleUpdate, handleSaveMessage}) => {

    return (
        <div className="flex  mt-6">
        <form action="#" className="relative flex-auto border-t  px-2 border-gray-500">
            <div className="overflow-hidden bg-white rounded-lg pb-12 p-2 ">
                <label htmlFor="comment" className="sr-only">
                    Nachricht schreiben...
                </label>
                <textarea
                    rows={2}
                    value={(message !== null) ? message : ""}
                    onChange={(e) => handleUpdate(e)}
                    name="comment"
                    id="comment"
                    className="block w-full resize-none border-0 bg-transparent py-1.5 text-gray-900  placeholder:text-gray-600 focus:ring-0 sm:text-sm sm:leading-6"
                    placeholder="Nachricht schreiben... "

                />
            </div>

            <div className="absolute inset-x-0 bottom-4 flex flex-row-reverse pl-3 lg:pr-6 pr-4">
                <button onClick={handleSaveMessage} className="rounded-md bg-gray-900 px-2.5 cursor-pointer py-1.5 text-sm font-semibold text-white   hover:bg-gray-600">
                    Senden
                </button>
            </div>
        </form>
    </div>
    );
}

export default MessageInput;